import { ApplicationsModule } from './../applications/applications.module';
import { HttpClientModule } from '@angular/common/http';
import { Inject, ModuleWithProviders, NgModule, Optional } from '@angular/core';
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StorageModule } from '@ngx-pwa/local-storage';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PipAppbarModule, PipMediaModule, PipSidenavModule, PipSidenavPosition } from 'pip-webui2-layouts';
import { PipNavModule } from 'pip-webui2-nav';
import { PipThemesModule, pipWebUI2Themes } from 'pip-webui2-themes';
import { EventModifiersPlugin, WINDOW_PROVIDERS } from '../common/index';
import { GaSessionModule } from '../session/index';
import { AccountsModule } from './../accounts/accounts.module';
import { GaShellComponentsModule } from './components/index';
import { GaShellLayoutsModule } from './layouts/index';
import { defaultGaConfig, GaConfig, GA_CONFIG, GA_CONFIG_FROM_FILE } from './models/Config';
import { GaCheckUpdateService } from './services/check-updates.service';
import { GaConfigService } from './services/config.service';
import { I18nService } from './services/i18n.service';
import { GaShellRoutingModule } from './shell-routing.module';

// @dynamic
@NgModule({
  imports: [
    // Angular and vendors
    EffectsModule.forRoot([]),
    HttpClientModule,
    StoreModule.forRoot({}),
    StorageModule.forRoot({
      LSPrefix: 'ga.',
      IDBDBName: 'guru-admin'
    }),
    TranslateModule.forRoot(),
    // pip-suite2 & pip-webui2
    PipAppbarModule.forRoot(),
    PipNavModule.forRoot(),
    PipMediaModule.forRoot(),
    PipSidenavModule.withConfig({
      start: {
        views: [
          {
            name: 'tablet',
            alias: 'lt-md',
            position: PipSidenavPosition.Root,
            mode: 'side',
            collapsed: true,
            opened: true,
            active: false
          },
          {
            name: 'mobile',
            alias: 'lt-sm',
            position: PipSidenavPosition.Root,
            mode: 'over'
          }
        ]
      },
      end: {
        views: [
          {
            name: 'default',
            position: PipSidenavPosition.Root,
            mode: 'side',
            width: 350
          },
          {
            name: 'mobile',
            alias: 'lt-sm',
            position: PipSidenavPosition.Root,
            mode: 'over'
          }
        ]
      }
    }),
    PipThemesModule.withConfig({
      themes: [
        pipWebUI2Themes.Blue
      ]
    }),
    // ga
    GaShellRoutingModule,
    GaShellComponentsModule,
    GaShellLayoutsModule,
    GaSessionModule.forRoot(),
    AccountsModule,
    ApplicationsModule
  ]
})
export class GaShellModule {
  static forRoot(config?: GaConfig): ModuleWithProviders<GaShellModule> {
    return {
      ngModule: GaShellModule,
      providers: [
        {
          provide: GA_CONFIG,
          useValue: defaultGaConfig,
          multi: true
        },
        {
          provide: GA_CONFIG,
          useValue: config,
          multi: true
        },
        {
          provide: EVENT_MANAGER_PLUGINS,
          useClass: EventModifiersPlugin,
          multi: true
        },
        GaCheckUpdateService,
        GaConfigService,
        I18nService,
        // I18nService,
        WINDOW_PROVIDERS,
      ]
    };
  }

  constructor(
    configService: GaConfigService,
    @Optional() @Inject(GA_CONFIG) configs: GaConfig[],
    @Optional() @Inject(GA_CONFIG_FROM_FILE) configFromFile: GaConfig,
    i18nService: I18nService,
    translate: TranslateService,
  ) {
    if (configs) {
      configs.forEach(config => configService.addConfig(config));
    }
    if (configFromFile) {
      configService.addConfig(configFromFile);
    }
    translate.setDefaultLang(configService.i18n.application?.defaultLanguage ?? configService.language);
    translate.use(configService.language);
    i18nService.registerModule('pg-shell');
  }
}
